<script setup>
import { computed } from 'vue'
import { useFilingDetailStore } from '../../stores/filingDetailStore'
import { useRoute, useRouter } from 'vue-router'
import StatusBadge from './StatusBadge.vue'

const filingDetailStore = useFilingDetailStore()
const route = useRoute()
const router = useRouter()

const companyInfo = computed(() => filingDetailStore.currentFiling)

const editCompanyInfoPath = computed(() => {
  return `/a/${route.params.teamSlug}/filings/${route.params.filingId}/edit-company-info/`
})

const navigateToEditCompanyInfo = () => {
  router.push(editCompanyInfoPath.value)
}
</script>

<template>
  <div class="card shadow-none border mb-3">
    <div class="card-header border-bottom pb-3 d-block align-items-center">
      <h3 class="card-title mb-2">Company Information</h3>
      <StatusBadge :isComplete="filingDetailStore.isCompanyDetailsComplete" />
    </div>
    <div class="card-body p-4">
      <div class="row">
        <div class="col-md-6">
          <dl>
            <dt>Legal Name</dt>
            <dd>{{ companyInfo.reportingCompanyLegalName }}</dd>

            <dt>Alternate Name or DBA</dt>
            <dd>{{ companyInfo.alternateName || 'None' }}</dd>

            <dt>Formed In</dt>
            <dd>
              <template v-if="filingDetailStore.isFormationComplete">
                {{ companyInfo.stateOfFormation }},
                {{ companyInfo.countryOfFormation }}
              </template>
              <span v-else class="badge bg-soft-danger text-danger">
                <i class="fa-light fa-exclamation-circle"></i> Missing Formation
                Details
              </span>
            </dd>

            <dt>{{ companyInfo.taxIdTypeDisplay }}</dt>
            <dd>
              <template v-if="filingDetailStore.isTaxDetailsComplete">
                {{ companyInfo.taxIdNumber }}
              </template>
              <span v-else class="badge bg-soft-danger text-danger">
                <i class="fa-light fa-exclamation-circle"></i> Missing Tax ID
              </span>
            </dd>
          </dl>
        </div>
        <div class="col-md-6">
          <dl>
            <template v-if="companyInfo.tribalJurisdiction">
              <dt>Tribal Jurisdiction</dt>
              <dd>
                {{ companyInfo.tribalJurisdiction }}
                <template v-if="!filingDetailStore.isTribalInfoComplete">
                  <br />
                  <span class="badge bg-soft-danger text-danger">
                    <i class="fa-light fa-exclamation-circle"></i> Incomplete
                  </span>
                </template>
              </dd>

              <dt>Name of Tribe</dt>
              <dd>{{ companyInfo.nameOfTribe || 'N/A' }}</dd>
            </template>

            <dt>Existing Reporting Company</dt>
            <dd>{{ companyInfo.existingReportingCompany ? 'Yes' : 'No' }}</dd>

            <dt>Foreign Pooled Investment Vehicle</dt>
            <dd>
              {{ companyInfo.foreignPooledInvestmentVehicle ? 'Yes' : 'No' }}
            </dd>
            <dt>Contact Email</dt>
            <dd>
              {{ companyInfo.contactEmail }}
              <template v-if="!companyInfo.contactEmail">
                <br />
                <span class="badge bg-soft-danger text-danger">
                  <i class="fa-light fa-exclamation-circle"></i> Incomplete
                </span>
              </template>
            </dd>
          </dl>
        </div>
      </div>

      <div class="d-flex gap-2 justify-content-start mt-3">
        <div class="d-grid col-md-3">
          <button
            v-editable
            @click="navigateToEditCompanyInfo"
            class="btn btn-sm btn-outline-primary"
            type="button"
          >
            <i class="fa-light fa-pen-to-square" aria-hidden="true"></i> Edit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
